/**
 * 专利卫士 涉及组织国家
 */
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
      <el-breadcrumb-item>申请预评估报告</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="搜索：">
        <el-input size="small" v-model="formInline.mobile" style="width:160px" placeholder="输入手机号" clearable></el-input>
      </el-form-item>
      <el-form-item label="状态：">
        <el-select size="small" v-model="formInline.status" style="width:100px" placeholder="请选择">
          <el-option v-for="type in status" :label="type.key" :value="type.value" :key="type.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-search" @click="search">搜索</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="warning" title="导出勾选中的数据" @click="exportCheck">导出</el-button>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="warning" title="导出满足条件的数据" @click="exportAll">全部导出</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <el-table size="small" ref="multipleTable" :data="listData" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;" tooltip-effect="dark"  @selection-change="handleSelectionChange">
      <el-table-column align="center" type="selection" width="80">
      </el-table-column>
      <el-table-column align="center" type="index" label="序号" width="80">
      </el-table-column>
      <el-table-column prop="id" v-if="idShow">
      </el-table-column>
      <el-table-column prop="title" align="center" label="标题" min-width="140" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="total_fee" align="center" label="金额" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" prop="status" label="订单状态" width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper" style="text-align: center">
              <el-tag :type="ASSET_STATUS[scope.row.status].type">
                {{ASSET_STATUS[scope.row.status].status}}
              </el-tag>
            </div>
          </template> 
      </el-table-column>
       <el-table-column align="center" prop="reportStatus" label="报告状态" width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <div slot="reference" class="name-wrapper" style="text-align: center">
              <el-tag :type="ASSET_PRE_STATUS[scope.row.reportStatus].type">
                {{ASSET_PRE_STATUS[scope.row.reportStatus].status}}
              </el-tag>
            </div>
          </template> 
      </el-table-column>
      <el-table-column prop="name" align="center" label="昵称" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="mobile" align="center" label="手机号" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="add_time" align="center" label="下单时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="pay_time" align="center" label="支付时间" show-overflow-tooltip>
      </el-table-column>
      <el-table-column prop="bz" align="center" label="备注" show-overflow-tooltip>
      </el-table-column>
      <el-table-column align="center" label="操作" min-width="120">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" @click="viewReport(scope.$index, scope.row)" title="预览报告">预览</el-button>
          <!-- <el-button size="mini" type="primary" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="delCountry(scope.$index, scope.row)">删除</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
  </div>
</template>

<script>
import { exportCheckPreReportOrder, exportSearchPreReportOrder, editCountry, delCountry, wechatUrl, getPreReportOrderList } from '../../api/wechatMG'
import Pagination from '../../components/Pagination'
import { checkLogin } from '../../utils/util'
export default {
  data() {
    return {
      idShow: false,
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '',
      multipleSelection: [],
      infoForm: {
        id: '',
        name: '',
        type: '',
        flag: '',
        sign: '',
        sort: '',
        status: ''
      },
      ASSET_STATUS: {
      '1': { 'status': '未支付', 'type': 'info' },
      '2': { 'status': '已支付', 'type': 'primary' }
      },
      ASSET_PRE_STATUS: {
      '1': { 'status': '订单未支付', 'type': 'info' },
      '2': { 'status': '报告生成中', 'type': 'primary' },
      '3': { 'status': '报告生成中', 'type': 'primary' },
      '4': { 'status': '报告生成中', 'type': 'primary' },
      '5': { 'status': '报告已生成', 'type': 'primary' },
      },
      status: [
        { key: '全部', value: 0 },
        { key: '未支付', value: 1 },
        { key: '已支付', value: 2 }
      ],
       formInline: {
        page: 1,
        ps: 10,
        documentNum: '',
        mobile: '',
        status: 2
      },
      listData: [], //用户数据
      // 分页参数
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
         // 表单验证

    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
    this.getdata(this.formInline)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {

        // 图片上传相关
    handleAvatarSuccess(res, file) {
      if(res.code == 200){
          // this.imageUrl = res.data.url;
          this.infoForm.flag = res.data.url
      }else{
          this.$message({
              type: 'error',
              message: res.msg
            })
      }
        // this.imageUrl = URL.createObjectURL(file.raw);
      },
    beforeAvatarUpload(file) {
        // const isJPG = file.type === 'image/jpeg';
        const isJPG = true;
        const isLt2M = file.size / 1024 / 1024 < 10;

        if (!isJPG) {
          this.$message.error('上传头像图片只能是 JPG 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传头像图片大小不能超过 10MB!');
        }
        return isJPG && isLt2M;
      },


    // 获取公司列表
    getdata(parameter) {
        this.loading = true
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
      getPreReportOrderList(parameter)
        .then(res => {
          this.loading = false
          res = checkLogin(res);
          if (res.code == 200) {
            this.listData = res.data.dataList
            // 分页赋值
            this.pageparm.currentPage = this.formInline.page
            this.pageparm.pageSize = this.formInline.limit
            this.pageparm.total = res.data.total
          } else {
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('登陆已过期,请重新登陆!')
        })
    },
    // 显示编辑页面
    handleEdit: function(index,row){
      if(row){
        this.infoForm.id = row.id
        this.infoForm.name = row.name
        this.infoForm.type = row.type
        this.infoForm.sign = row.sign
        this.infoForm.flag = row.flag
        this.infoForm.sort = row.sort
        this.infoForm.status = row.status
        this.title = '编辑信息'
      }else{
        this.title = '添加信息'
        this.infoForm.id = ''
        this.infoForm.name = ''
        this.infoForm.type = ''
        this.infoForm.sign = ''
        this.infoForm.flag = ''
        this.infoForm.sort = ''
        this.infoForm.status = ''
      }
      this.editFormVisible = true
    },
    // 分页插件事件
    callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.ps = parm.pageSize
      this.getdata(this.formInline)
    },
    // 搜索事件
    search() {
      this.getdata(this.formInline)
    },
    handleSelectionChange(val){
      this.multipleSelection = val;
    },
    //显示详情界面
    handleInfo: function(index, row) {
      console.log(row)
      this.editFormVisible = true
      this.infoForm = row
    },
    // 保存组织国家
    saveCountry(infoForm){
        //校验参数
      this.$refs[infoForm].validate(valid => {
        if(valid){
           editCountry(this.infoForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              res = checkLogin(res)
              if (res.code == 200) {
                this.getdata(this.formInline)
                this.$message({
                  type: 'success',
                  message: res.msg
                })
              } else {
                this.$message({
                  type: 'error',
                  message: res.msg
                })
              }
            })
        }else{
          return false;
        }
      })
    },
    // 删除规费指引
    delCountry(index, row) {
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(()=>{
        delGuide({id: row.id})
        .then(res=>{
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: res.msg
            })
            this.getdata()
          }else{
            this.$message({
              type: 'error',
              message: res.msg
            })
          }
        })
      }).catch(() => {
          this.loading = false
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    // 关闭编辑、增加弹出框
    closeDialog(formName) {
      this.editFormVisible = false
      this.$refs[formName].resetFields()
    },
    // 预览报告
    viewReport(index, row) {
      let reportUrl = row.report_url
      if(reportUrl.length <= 0){
        this.$message({
          type: 'info',
          message: '报告不存在!'
        })
        return false
      }
      console.log(reportUrl)
      window.open(reportUrl)
    },
    // 类型
    typeFormat:function(row,column){
        if(row.type == 1){
            return '组织'
        }else if(row.type == 2){
            return '国家'
        }else{
            return '未知'
        }
    },
    // 状态
    statusFormat:function(row,column){
        if(row.status == 1){
            return '未启用'
        }else if(row.status == 2){
            return '已启用'
        }else{
            return '未知'
        }
    },
      // 导出选中的数据
      exportCheck() {
      const checkedArr = this.multipleSelection;
      const idsArr = [];
      checkedArr.forEach(function(item,index){
          idsArr.push(item.id)
      });
      if(idsArr.length <= 0){
            this.$message({
              type: 'info',
              message: '未勾选任何记录'
          })
          return false;
      }
       this.$confirm('确定导出勾选的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
      .then(() => {
          const idStr = JSON.stringify(idsArr)
          exportCheckPreReportOrder({ids: idStr})
          .then( res=> {
            if(res.code == 200){
              this.$message({
                type: 'success',
                message: '导出成功!'
              })
              window.location.href = res.data.url
            }else{
              this.$message({
                type: 'error',
                message: res.msg
              })
            }
          })
       })
       .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
    // 导出满足条件的数据
    exportAll() {
       this.$confirm('确定导出所有满足条件的记录吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
      })
       .then(() => {
        exportSearchPreReportOrder(this.formInline)
        .then(res => {
          if(res.code == 200){
            this.$message({
              type: 'success',
              message: '导出成功!'
            })
            window.location.href = res.data.url
          }else{
            this.$message({
              type: 'info',
              message: res.msg
            })
          }
        })
      })
      .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消导出'
          })
        })
    },
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.avatar-uploader .el-upload {
  border: 1px dashed #868484b5;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 180px;
  height: 96px;
  display: block;
}
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/wechat/PreOrder.vue